import React from 'react';
import { Outlet } from 'react-router-dom';

const ClaimsLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
};

export default ClaimsLayout;
